import validation from '../../../scripts/services/validation';

export default [
  '$scope', '$uibModalInstance', 'popupService', 'reportService', 'deviceService',
  function ($scope, $uibModalInstance, popupService, reportService, deviceService) {
  this.isMobile = deviceService.isMobile;
  $scope.$watch('form', () => {
    this.validationEmail = validation(this.form, 'email', {
      required: 'Введите email',
      email: 'Введите корректный email',
    });

    this.validationMessage = validation(this.form, 'message', {
      required: 'Введите текст сообщения',
    });
  });

  this.sendReport = () => {
    this.form.$setSubmitted(true);
    if (!this.form.$valid) {
      return;
    }

    // TODO показать уведомление в правом углу
    reportService
      .sendFeedback({
        email: this.email,
        text: this.message,
      })
      .then(() => {
        $uibModalInstance.dismiss('sent');
        popupService.openPopup('reportMessageOk');
      }, () => {
        $uibModalInstance.dismiss('error');
        popupService.openPopup('reportMessageError');
      });
  };
}];
